import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CitizenHomeComponent } from './citizens/home-pages/citizen-home/citizen-home.component';
import { CitizenDashboardComponent } from './citizens/home-pages/citizen-dashboard/citizen-dashboard.component';
import { Citizen404NotFoundComponent } from './citizens/home-pages/citizen-404-not-found/citizen-404-not-found.component';
import { CitizenPublicationsComponent } from './citizens/home-pages/citizen-publications/citizen-publications.component';
import { CitizenHomeLayoutComponent } from './citizens/home-pages/citizen-home-layout/citizen-home-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: CitizenHomeLayoutComponent,
    children: [
      { path: '', component: CitizenHomeComponent },
      { path: 'publications', component: CitizenPublicationsComponent },
      { path: 'statistiques', component: CitizenDashboardComponent },
    ],
  },
  {
    path: 'portail-citoyen',
    loadChildren: () =>
      import('./citizens/back-office/citizen-back-office.module').then(
        (mod) => mod.CitizenBackOfficeModule
      ),
  },
  { path: '**', component: Citizen404NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {}
